import { render, staticRenderFns } from "./AttributeEditorComponent.vue?vue&type=template&id=65c8ae28&scoped=true"
import script from "./AttributeEditorComponent.vue?vue&type=script&lang=js"
export * from "./AttributeEditorComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c8ae28",
  null
  
)

export default component.exports